import moment from 'moment';

import createReducer from 'reducers/createReducer';

import { Notice } from 'actions/actionTypes';

import { ArrayConcat } from 'utils/functions';

const INITIAL_STATE = {
    searchFilter: {
        searchStartDate: moment().format('YYYY-MM-DDTHH:mmZ'),
        page: 1,
        pageSize: 10,
        postTypeCode: [
            'post_type_cd:notice',
            'post_type_cd:event',
            'post_type_cd:update',
        ],
        searchText: '',
    },
    noticeList: {
        maxPage: 0,
        totalCount: 0,
        list: [],
    },
    noticeInfo: {
        boardId: 0,
        postTypeCode: '',
        title: '',
        content: '',
        updateTime: '',
        cdn: '',
        attachmentsList: [],
    },
    error: {
        triggered: false,
        message: '',
    },
};

// 리듀서
const reducer = createReducer(INITIAL_STATE, {
    // 이벤트
    [Notice.CHANGE_NOTICE_SEARCH_FILTER]: (state, action) => {
        if (action.payload.type === 'checkbox') {
            state.searchFilter[action.payload.name] = ArrayConcat(
                Array.from(state.searchFilter[action.payload.name]),
                action.payload.value
            );
        } else {
            state.searchFilter[action.payload.name] = action.payload.value;
        }
    },

    // 검색 필터 초기화
    [Notice.SEARCH_FILTER_RESET]: (state, action) => {
        state.searchFilter = INITIAL_STATE.searchFilter;
    },

    // 공지사항 글 목록 조회
    [Notice.LOAD_NOTICE_LIST_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [Notice.LOAD_NOTICE_LIST_SUCCESS]: (state, action) => {
        state.searchFilter.page = action.payload.currentPage;
        state.noticeList.maxPage = action.payload.maxPage;
        state.noticeList.totalCount = action.payload.totalCount;
        state.noticeList.list = action.payload.list;
    },
    [Notice.LOAD_NOTICE_LIST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },

    // 공지사항 글 상세 조회
    [Notice.LOAD_NOTICE_INFO_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
        state.noticeInfo.idx = Number(action.payload);
    },
    [Notice.LOAD_NOTICE_INFO_SUCCESS]: (state, action) => {
        state.noticeInfo.boardId = action.payload.boardId;
        state.noticeInfo.postTypeCode = action.payload.postTypeCode.split(':')[1];
        state.noticeInfo.title = action.payload.title;
        state.noticeInfo.content = action.payload.content;
        state.noticeInfo.regTime = action.payload.regTime;
        state.noticeInfo.cdn = action.payload.cdn;
        state.noticeInfo.attachmentsList = action.payload.attachmentsList;
    },
    [Notice.LOAD_NOTICE_INFO_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },
});

export default reducer;
